import ApplicationSerializer from 'lumen/serializers/application';

export default class CustomTagListOptionSerializer extends ApplicationSerializer {
  attrs = {
    subscriberCount: { serialize: false },
    definition: { serialize: false },
  };

  payloadKeyFromModelName(): string {
    return 'custom_tag_list_option';
  }
}
